<div *ngIf="DontShow == false" class="loading-screen text-center" role="status" [attr.aria-label]="'LOADING_CHURCH_SERVICES' | translate">
    <div class="church-loader" aria-hidden="true">
        <span class="church-loader__ring"></span>
        <span class="church-loader__accent"></span>
        <img *ngIf="logoSource" class="church-loader__logo" [src]="logoSource" alt="" (error)="onLogoError()" />
        <span *ngIf="!logoSource" class="church-loader__fallback">✝</span>
    </div>
    <div class="loading-screen__message">
        <span *ngIf="globalService.resourceArr.length > 0" [class.SmallArabicFont]="globalService.isRTL == true">{{ globalService.resourceArr == null || globalService.resourceArr.length == 0? ('WAITED_LONG?' | translate) : globalService.Get("WAITED_LONG?") }}</span>
        <br><br>
        <button type="button" class="btn btn-primary" data-toggle="button" (click)="GoHome()" aria-pressed="false"
            autocomplete="off" [class.SmallArabicFont]="globalService.isRTL == true">
            {{ globalService.resourceArr == null || globalService.resourceArr.length == 0? ('CLICK_HERE' | translate) :globalService.Get("CLICK_HERE") }}
        </button>
    </div>
</div>
